import {
  FETCH_DESIGNATIONS,
  FETCH_DESIGNATIONS_SUCCESS,
  FETCH_DESIGNATIONS_FAILURE,
  CREATE_DESIGNATION_REQUEST,
  CREATE_DESIGNATION_SUCCESS,
  CREATE_DESIGNATION_FAILURE,
  DELETE_DESIGNATION,
  DELETE_DESIGNATION_SUCCESS,
  DELETE_DESIGNATION_FAILURE,
} from "./actionTypes";

// Fetch Designations
export const fetchDesignations = (unitId) => ({
  type: FETCH_DESIGNATIONS,
  payload: { unitId },
});

export const fetchDesignationsSuccess = (designations) => ({
  type: FETCH_DESIGNATIONS_SUCCESS,
  payload: designations,
});

export const fetchDesignationsFailure = (error) => ({
  type: FETCH_DESIGNATIONS_FAILURE,
  payload: error,
});

// Create Designation
export const createDesignationRequest = (formData, isEdit = false) => ({
  type: CREATE_DESIGNATION_REQUEST,
  payload: { formData, isEdit },
});

export const createDesignationSuccess = (response) => ({
  type: CREATE_DESIGNATION_SUCCESS,
  payload: response,
});

export const createDesignationFailure = (error) => ({
  type: CREATE_DESIGNATION_FAILURE,
  payload: error,
});

// Delete Designation
export const deleteDesignation = (deleteDesign) => ({
  type: DELETE_DESIGNATION,
  payload: deleteDesign,
});

export const deleteDesignationSuccess = (response) => ({
  type: DELETE_DESIGNATION_SUCCESS,
  payload: response,
});

export const deleteDesignationFailure = (error) => ({
  type: DELETE_DESIGNATION_FAILURE,
  payload: error,
});
